import {Button} from "@material-ui/core";
import React from "react";
import {useTranslation} from "react-i18next";
import {exportDataToCsv} from "../../utils/export-to-csv";

export const CsvExport = (props: any) => {
    const {t} = useTranslation();
    const {contentBuilder, filenameBuilder, exportOptions, onError} = props;

    const clickHandler = async () => {
        try{
            void await exportDataToCsv(contentBuilder, filenameBuilder, exportOptions);
        }
        catch(err) {
            onError(t('_Shared.CSV.Error.ExportFailed'))
        }
    }

       return  <Button variant="outlined" color="primary" size="medium"
                    onClick={clickHandler}>
        {props.children}
    </Button>
}
